import * as React from "react";
import styled from "@emotion/styled";
import {
  Button,
  CopyToClipboard,
  DropdownMenu,
  Hr,
  Link,
  List,
  Stack,
  Text,
} from "atoms";
import { Artist, Project } from "../types";

interface InviteMenuProps {
  reviewable: Artist | Project;
  isAdmin: boolean;
  isArtist: boolean | undefined;
  isInviteMenuOpen: boolean;
  toggleInviteMenu: () => void;
}

function InviteMenu({
  reviewable,
  isAdmin,
  isArtist,
  isInviteMenuOpen,
  toggleInviteMenu,
}: InviteMenuProps) {
  const [isCopyUrlSuccess, setIsCopyUrlSuccess] = React.useState(false);

  const profileUrl = `https://thehug.xyz/artists/${reviewable.id}`;

  React.useEffect(() => {
    if (isCopyUrlSuccess === true) {
      const timeout = setTimeout(() => {
        setIsCopyUrlSuccess(false);
      }, 1000 * 6);
      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [isCopyUrlSuccess]);

  if (!isAdmin && !isArtist) return null;

  return (
    <InviteMenuWrapper>
      <InviteMenuToggle
        type="button"
        size="xxs"
        onClick={toggleInviteMenu}
        aria-label={`${isInviteMenuOpen ? "Close" : "Open"} invite menu`}
        aria-controls="#invite"
        aria-expanded={isInviteMenuOpen}
        variant="secondary"
      >
        Invite
      </InviteMenuToggle>

      <InviteMenuDropdown isOpen={isInviteMenuOpen} id="invite">
        {isArtist && (
          <>
            <Stack gap="xs">
              <InviteLinkHeading bold size="xxxs">
                Invite Followers
              </InviteLinkHeading>
              <List type="blank">
                <li>
                  <SCopyToClipboard
                    buttonText="Copy invite link"
                    value={`${profileUrl}?follow`}
                  />
                </li>
                <li>
                  <SCopyToClipboard
                    buttonText="Copy invite link with message"
                    value={`Follow me on HUG to hear about drops, announcements, and other updates. ${profileUrl}?follow`}
                  />
                </li>
              </List>
            </Stack>
            <SHr aria-hidden />
          </>
        )}
        {(isArtist || isAdmin) && (
          <Stack>
            <InviteLinkHeading bold size="xxxs">
              Invite Artists
            </InviteLinkHeading>
            <List type="blank">
              {isArtist && (
                <li>
                  <Link to="/artist-invites">
                    Invite an Artist to Apply for a Profile
                  </Link>
                </li>
              )}
              {isAdmin && (
                <li>
                  <Link to={`/artist-invite/${reviewable.id}`}>
                    Invite an Artist to Claim this Profile
                  </Link>
                </li>
              )}
            </List>
          </Stack>
        )}
      </InviteMenuDropdown>
    </InviteMenuWrapper>
  );
}

const InviteMenuWrapper = styled.div({
  right: 0,
  display: "block",
  position: "relative",
  width: "min-content",
});

interface WithIsOpen {
  isOpen: boolean;
}

const InviteMenuToggle = styled(Button)({
  alignItems: "center",
  display: "block",
  justifyContent: "center",
  paddingLeft: 10,
  paddingRight: 10,
  lineHeight: 1.2,
  svg: {
    pointerEvents: "none",
    fontSize: "1em",
    transform: "scale(1.2)",
  },
});

const SCopyToClipboard = styled(CopyToClipboard)({
  svg: { order: 99 },
});

const InviteMenuDropdown = styled(DropdownMenu)<WithIsOpen>({
  // maxWidth: "200px",
});

const SHr = styled(Hr)({
  margin: 0,
});

const InviteLinkHeading = styled(Text)(({ theme }) => ({
  // color: theme.colors.fg,
  textTransform: "uppercase",
}));
export { InviteMenu };
